var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Model, Prop, Vue } from 'vue-property-decorator';
import { FORM_OVERRIDE_FORCE_FALSE_VALUE, INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import * as styles from "./style.module.css";
import { TripleCheckBox } from "../../../../lib/builtin/designerComponents/MultiRatioInput/TripleCheckBox";
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
// false定义为继承
const CHECK_BOX_VALUE_SEQUENCE = [false, true, FORM_OVERRIDE_FORCE_FALSE_VALUE];
const VALUE_SEQUENCE_META = {
  false: '继承上级配置',
  true: '启用',
  [FORM_OVERRIDE_FORCE_FALSE_VALUE]: '禁用'
};
let MultiRatioInput = class MultiRatioInput extends Vue {
  /** 低配版三button单选框模式 */
  renderRadioGroup() {
    const h = this.$createElement;
    return h("a-radio-group", {
      "attrs": {
        "value": this.value
      },
      "on": {
        "change": e => this.$emit('change', e.target.value)
      }
    }, [h("a-radio-button", {
      "attrs": {
        "value": false
      }
    }, ["\u7EE7\u627F"]), h("a-radio-button", {
      "attrs": {
        "value": true
      }
    }, ["\u2713"]), h("a-radio-button", {
      "attrs": {
        "value": FORM_OVERRIDE_FORCE_FALSE_VALUE
      }
    }, ["x"])]);
  }
  /** 三态多选框 */
  renderTripleCheckBox() {
    var _this$schema, _this$schema2;
    const h = this.$createElement;
    return h("a-tooltip", {
      "attrs": {
        "placement": "topLeft",
        "overlayClassName": mergeClassName(styles.tooltip, this.value !== false && styles.hide)
      }
    }, [h("div", {
      "slot": "title"
    }, [VALUE_SEQUENCE_META[this.value]]), h(TripleCheckBox, {
      "class": styles.checkBox,
      "attrs": {
        "value": this.value,
        "valueSequence": CHECK_BOX_VALUE_SEQUENCE
      },
      "on": {
        "change": e => this.$emit('change', e)
      }
    }, [h("span", [((_this$schema = this.schema) === null || _this$schema === void 0 ? void 0 : _this$schema.title) || ((_this$schema2 = this.schema) === null || _this$schema2 === void 0 ? void 0 : _this$schema2.id)])])]);
  }
  render() {
    return this.useRadio ? this.renderRadioGroup() : this.renderTripleCheckBox();
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], MultiRatioInput.prototype, "designer", void 0);
__decorate([Model('change')], MultiRatioInput.prototype, "value", void 0);
__decorate([Prop({
  type: Object
})], MultiRatioInput.prototype, "schema", void 0);
__decorate([Prop({
  default: false
})], MultiRatioInput.prototype, "useRadio", void 0);
MultiRatioInput = __decorate([Component({
  name: 'multiRatioInput'
})], MultiRatioInput);
export default MultiRatioInput;
//# sourceMappingURL=index.js.map
